import { render } from "./PaymentProvidersView.vue?vue&type=template&id=11b9680c&scoped=true&ts=true"
import script from "./PaymentProvidersView.vue?vue&type=script&lang=ts"
export * from "./PaymentProvidersView.vue?vue&type=script&lang=ts"

import "./PaymentProvidersView.vue?vue&type=style&index=0&id=11b9680c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b9680c"]])

export default __exports__